const Helper = {
  trace: (data) => {
    console.log(data);
  },

  encodeData: (data) => {
    const payload = [];

    for (const [key, value] of Object.entries(data)) {
      payload.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }

    return payload.join("&");
  },
};

export default Helper;
